import React from 'react';
import { TextField } from '@mui/material';

const CustomTextField = (props) => {
  return (
    <TextField
      {...props}
      variant="outlined"
      fullWidth
      sx={{
        height: '52px',
        backgroundColor: props.disabled ? '#cdcdcf' : '#fff',

        borderRadius: '12px',
        '& .MuiOutlinedInput-root': {
          padding: '0 12px',
          border: '1px solid #C1C1C1',
          borderRadius: '12px',
          color: '#222 !important',
          '& fieldset': {
            border: 'none',
            backgroundColor: props.disabled ? '#cdcdcf' : '#fff',
          },
        },
        '& .MuiInputBase-input': {
          '-webkit-text-fill-color': props.disabled ? '#555 !important' : '#222 !important',
          zIndex: 1,
        },
        '& input': {
          fontSize: '14px',
          fontWeight: '400',
          color: '#222',
          '&::placeholder': {
            color: '#C1C1C1',
            fontSize: '14px',
            fontWeight: '400',
          },
          '&::selection': {
            backgroundColor: '#C1C1C1',
            color: '#000',
          },
        },
      }}
    />
  );
};

export default CustomTextField;
